module.exports = __webpack_public_path__ + "img/Vikinger.423f611a.jpg";